import React from "react";
import { useLocation } from "react-router-dom";
import { Container, Typography } from "@mui/material";
import { useTheme } from "styled-components";
import ChallengeList from "./organisms/ChallengeList";
import ContentList from "./organisms/ContentList"; // Import ContentList

const EventContentPage = () => {
  const location = useLocation();
  const { event } = location.state || {};
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, fontFamily: "basic-sans"}}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontWeight: 300, fontFamily: "basic-sans", mb: 8 }}
      >
        Edit & Add Content for "{event?.title || "Event"}"
      </Typography>

      {/* Render list of saved content */}
      <ContentList theme={theme} event={event} />

      {/* Render list of challenges */}
      <ChallengeList theme={theme} event={event} />
    </Container>
  );
};

export default EventContentPage;
